/*
 * Dong Hai Theme
 *
 * Use this file to add custom Javascript to Dong Hai.  Keeping your custom
 * Javascript in this fill will make it easier to update Dong Hai. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function (scrollLock, Flickity, themeCurrency, Ajaxinate, Swiper) {
  window.theme.token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb25uZWN0X3Nob3BpZnlfaWQiOjJ9.vxVhTXOTX-BSmt9ILD69kMyaaVcgG-o3y9WlQ5jXrzg";
  const tailwindSizes = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536,
  };

  function getCookieUTM(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    } else {
      return "";
    }
  }

  function containsUnsafeTags(str) {
    return /<|<\/|script|scr/i.test(str);
  }

  var showDescription = document.querySelector("[data-show-description]");
  var btnDatHangNhanh = document.querySelector("#btn-checkout");

  if (showDescription) {
    showDescription.addEventListener("click", (event) => {
      document.querySelector(".collection__text.collection__text-limit").classList.remove("collection__text-limit");
      showDescription.classList.add("hidden");
    });
  }

  btnDatHangNhanh.addEventListener("click", (event) => {
    if (btnDatHangNhanh.classList.contains("is-loading")) {
      return;
    }
    btnDatHangNhanh.classList.add("is-loading");
    const form = document.querySelector("#dh-form-checkout");
    const infoPhone = document.querySelector("#info__phone");
    const infoName = document.querySelector("#info__name");
    const infoAddress = document.querySelector("#info__address");
    const infoProvinces = document.querySelector("#info__provinces");
    const infoDistricts = document.querySelector("#info__districts");
    const infoWards = document.querySelector("#info__wards");
    const infoEmail = document.querySelector("#info__email");
    const infoGiftCart = document.querySelector("#info__gift-cart").value;
    const textareaGiftCart = document.querySelector("#gift-note").value;

    var reP = new RegExp("(086|087|096|097|098|032|033|034|035|036|037|038|039|089|090|093|070|079|077|076|078|088|091|094|083|084|085|081|082|092|056|058|099|059)[0-9]{7}");

    if (infoPhone.value.length == 0) {
      infoPhone.nextElementSibling.innerText = "Vui lòng nhập SĐT";
      infoPhone.nextElementSibling.classList.remove("hidden");
      btnDatHangNhanh.classList.remove("is-loading");
    } else if (infoPhone.value.length < 10) {
      infoPhone.nextElementSibling.innerText = "SĐT chưa đủ 10 ký tự";
      infoPhone.nextElementSibling.classList.remove("hidden");
      btnDatHangNhanh.classList.remove("is-loading");
    } else if (infoPhone.value.length > 10) {
      infoPhone.nextElementSibling.innerText = "SĐT vượt 10 ký tự";
      infoPhone.nextElementSibling.classList.remove("hidden");
      btnDatHangNhanh.classList.remove("is-loading");
    } else if (!reP.test(infoPhone.value)) {
      infoPhone.nextElementSibling.innerText = "Đầu số không hợp lệ";
      infoPhone.nextElementSibling.classList.remove("hidden");
      btnDatHangNhanh.classList.remove("is-loading");
    } else if (infoName.value == "") {
      infoName.nextElementSibling.innerText = "Vui lòng nhập họ tên";
      infoName.nextElementSibling.classList.remove("hidden");
      btnDatHangNhanh.classList.remove("is-loading");
    } else if (containsUnsafeTags(infoName.value)) {
      return;
    } else if (containsUnsafeTags(infoAddress.value)) {
      return;
    } else {
      infoPhone.nextElementSibling.classList.add("hidden");
      infoName.nextElementSibling.classList.add("hidden");

      const fullAddress = `${infoAddress.value}, ${infoWards.getAttribute("data-title")}, ${infoDistricts.getAttribute("data-title")}, ${infoProvinces.getAttribute("data-title")}`;

      var utm_source = "";
      var url = window.location.href;
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      if (urlParams.get("utm_source") == null) {
        utm_source = getCookieUTM("utm_cookie");
      } else {
        utm_source = urlParams.get("utm_source");
      }
      if (url.includes("fbclid=") == true && utm_source == "") {
        utm_source = "fbclid";
      }

      var productList = [];
      var dataPost = new FormData();
      dataPost.append("name", infoName.value);
      dataPost.append("phone", infoPhone.value);
      dataPost.append("note", infoGiftCart ? infoGiftCart : textareaGiftCart);
      dataPost.append("product", "");
      dataPost.append("SKU", "");
      dataPost.append("price", "");
      dataPost.append("sale team", "Đông Hải");
      dataPost.append("Địa chỉ", fullAddress);
      dataPost.append("statusForm", "Đông Hải");
      dataPost.append("token", window.theme.token);
      dataPost.append("variant", "");
      dataPost.append("variant_id", "");
      dataPost.append("device_post", navigator.userAgent);
      dataPost.append("device", navigator?.platform);
      dataPost.append("browser", navigator?.userAgentData?.vendor);
      dataPost.append("qty", 0);
      dataPost.append("utm_source", utm_source);

      let sumPrice = 0;
      document.querySelectorAll("#cart-drawer #cartItemsHolder .cart__item").forEach((item) => {
        const variant = item.getAttribute("data-dh-variant");
        const variant_id = item.getAttribute("data-dh-variant-id");
        const SKU = item.getAttribute("data-sku");
        const qty = item.querySelector(".cart__item__quantity input").value;
        const product = item.getAttribute("data-dh-title");
        const price = item.getAttribute("data-dh-price").replace("₫", "");
        sumPrice += Number(price);
        dataPost.set("variant", variant);
        dataPost.set("variant_id", variant_id);
        dataPost.set("SKU", SKU);
        dataPost.set("qty", qty);
        dataPost.set("product", product + " - (SKU: " + SKU + ")");
        dataPost.set("price", price);
        if (window.theme.zuciani.includes("stg")) {
          // Google sheet for STAGING TEST
          const scriptURL = "https://script.google.com/macros/s/AKfycbzbwjy8r7E07DPoxen4yxRxBdHI9WaUUqAWQ1SMStjBB0ANzZIyD5xpev8fSHwFfMa4/exec"; // Stg 2024 (dhn)
          fetch(scriptURL, { method: "POST", body: dataPost })
            .then((qo_response) => qo_response.json())
            .then((response) => console.log(response));
        } else {
          // Google sheet file by month
          var d = new Date();
          const scriptURL = window.theme.sheet[d.getMonth()];
          fetch(scriptURL, { method: "POST", body: dataPost })
            .then((qo_response) => qo_response.json())
            .then((response) => console.log(response));
        }
        productList.push({ variant_id: variant_id, quantity: qty });
      });
      // Xoá item của google sheet
      dataPost.delete("variant");
      dataPost.delete("variant_id");
      dataPost.delete("SKU");
      dataPost.delete("product");
      dataPost.delete("price");

      if (productList.length == 0) {
        return;
      }
      dataPost.set("products", JSON.stringify(productList));
      fetch(`${window.theme.zuciani}/api/web/quick_order_shopify_v2`, { method: "POST", body: dataPost })
        .then((qo_response) => qo_response.json())
        .then((qo) => {
          if (qo.datas.order_status_url) {
            //fixed and added by HieuTran - 03feb2026
            const eventId = qo.datas.order_id || Date.now();
            fbq("trackCustom", "DHN_Success", {currency: "VND",value: sumPrice}, {eventID: eventId});  
            
            fbq("track", "DHN Success", { currency: "VND", value: sumPrice });
            // Lưu thông tin liên hệ lần cuối cùng đặt hàng
            localStorage.setItem(
              "partner_info",
              JSON.stringify({
                phone: infoPhone.value,
                name: infoName.value,
                address: infoAddress.value,
                email: infoEmail.value,
                province: infoProvinces.value ? `${infoProvinces.value},${infoProvinces.getAttribute("data-title")}` : "",
                district: infoDistricts.value ? `${infoDistricts.value},${infoDistricts.getAttribute("data-title")}` : "",
                ward: infoWards.value ? `${infoWards.value},${infoWards.getAttribute("data-title")}` : "",
              }),
            );
            // chuyển hướng đi qua TKS page
            fetch(theme.routes.cart_clear_url + "?section_id=api-cart-items").then((response) => {
              btnDatHangNhanh.classList.remove("is-loading");
              location.href = qo.datas.order_status_url;
              // window.open(qo.datas.order_status_url, "_blank");
              // setTimeout(function () {
              //   location.reload();
              // }, 100);
            });
          } else {
            btnDatHangNhanh.classList.remove("is-loading");
          }
        });
    }
  });

  const selectors$1cc = {
    shopifySection: ".shopify-section",
    slider: "[data-slider]",
    holder: "[data-collection-slideshow-holder]",
    item: "[data-collection-slideshow-item]",
    flickityButton: ".flickity-button",
  };

  class CollectionSlideshow extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }
    get holder() {
      return this.querySelector(selectors$1cc.holder);
    }

    connectedCallback() {
      if (theme.settings.collectionSlideshow && window.innerWidth < window.theme.sizes.small) {
        try {
          // Safety check for holder
          if (!this.holder) {
            console.warn("CollectionSlideshow: Holder not found");
            return;
          }

          this.holder.querySelectorAll(".product__media__slide").forEach((item) => {
            item.classList.remove("hidden");
          });

          // Performance check - if too many slides, use virtual scrolling
          const slides = this.holder.querySelectorAll(".swiper-slide");
          if (slides.length > 100) {
            console.warn(`CollectionSlideshow: Large collection detected (${slides.length} slides), using virtual scrolling`);
          }

          // 1. Tạo một observer để theo dõi khi phần tử này xuất hiện trên màn hình
          const observer = new IntersectionObserver(
            (entries) => {
              // entries[0] chính là phần tử <collection-slideshow> này
              // isIntersecting là true nếu nó đang trong màn hình
              if (entries[0].isIntersecting) {
                // 2. Chỉ gọi init() MỘT LẦN khi nó vào màn hình
                if (!this.initialized) {
                  try {
                    this.init();
                    this.initialized = true; // Đánh dấu đã khởi tạo
                  } catch (error) {
                    console.error("CollectionSlideshow: Error during initialization:", error);
                    // Fallback: show first slide only
                    this.showFallback();
                  }
                }
                // 3. Ngừng theo dõi để tiết kiệm tài nguyên
                observer.unobserve(this);
              }
            },
            {
              rootMargin: "0px 0px 0px 0px",
              // rootMargin: "0px 0px 200px 0px", // Bắt đầu tải trước khi nó vào màn hình 200px
            },
          );

          // Bắt đầu theo dõi chính phần tử này
          observer.observe(this);
        } catch (error) {
          console.error("CollectionSlideshow: Error in connectedCallback:", error);
          this.showFallback();
        }
      } else {
        this.querySelector("[data-product-media-featured]").classList.remove("hidden");
      }
    }

    showFallback() {
      // Fallback method if Swiper fails
      const slides = this.holder.querySelectorAll(".swiper-slide");
      if (slides.length > 0) {
        slides.forEach((slide, index) => {
          if (index === 0) {
            slide.style.display = "";
          } else {
            slide.style.display = "none";
          }
        });
      }
    }

    disconnectedCallback() {
      // Cleanup resources to prevent memory leaks
      try {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        // Clear any timeouts
        if (this.loadTimeout) {
          clearTimeout(this.loadTimeout);
        }
      } catch (error) {
        console.error("CollectionSlideshow: Error during cleanup:", error);
      }
    }

    init() {
      this.swiper = new Swiper(this.holder, {
        slidesPerView: 1,
        spaceBetween: 10,
        lazy: true,
        loop: false,
        resizeObserver: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  }

  if (!customElements.get("collection-slideshow")) {
    customElements.define("collection-slideshow", CollectionSlideshow);
  }

  class RecentActivities extends HTMLElement {
    constructor() {
      super();
      this.flkty = null;
    }

    get buttonLoadMore() {
      return this.querySelector("#load-more");
    }

    get buttonYears() {
      return this.querySelectorAll("[data-year]");
    }

    get items() {
      return this.querySelectorAll("[data-recent-activities-item]");
    }

    get sliders() {
      return this.querySelectorAll("[data-slider]");
    }

    connectedCallback() {
      this.init();
      this.visibleItems();
    }

    init() {
      this.buttonYears.forEach((item) => {
        const lineItems = this.querySelectorAll("[data-line-item]");
        const lineDotItems = this.querySelectorAll("[data-line-dot-item]");

        item.addEventListener("click", () => {
          this.buttonYears.forEach((btItem) => {
            btItem.setAttribute("data-active", "false");
            btItem.classList.remove("bg-gray-800", "text-white");
            btItem.classList.add("bg-white", "text-gray-800");
          });
          item.setAttribute("data-active", "true");
          item.classList.add("bg-gray-800", "text-white");
          item.classList.remove("bg-white", "text-gray-800");

          // Hide all line items and dot items
          [...lineItems].forEach((lineItem) => {
            lineItem.classList.add("hidden");
          });
          [...lineDotItems].forEach((lineDotItem) => {
            lineDotItem.classList.add("hidden");
          });
          this.visibleItems();
        });
      });

      this.buttonLoadMore.addEventListener("click", () => {
        const buttonYearsActive = this.querySelector("[data-year][data-active='true']");
        const visible = buttonYearsActive.getAttribute("data-visible");
        buttonYearsActive.setAttribute("data-visible", Number(visible) + 4);
        this.visibleItems();
      });
    }

    visibleItems() {
      this.sliders.forEach((slider) => {
        slider.classList.add("hidden");
      });

      this.items.forEach((item) => {
        item.classList.add("hidden");
      });

      if (window.innerWidth >= tailwindSizes.sm) {
        this.visibleDesktop();
      } else {
        this.visibleMobile();
      }
    }

    visibleDesktop() {
      const buttonYearsActive = this.querySelector("[data-year][data-active='true']");
      const maxActivities = buttonYearsActive.getAttribute("data-max-activities");
      const visible = buttonYearsActive.getAttribute("data-visible");
      const year = buttonYearsActive.getAttribute("data-year");
      const slider = this.querySelector(`[data-slider="${year}"]`);
      const items = this.querySelectorAll(`[data-slider="${year}"] [data-recent-activities-item="${year}"]`);
      const lineItems = this.querySelectorAll(`[data-line-item="${year}"]`);
      const lineDotItems = this.querySelectorAll(`[data-line-dot-item="${year}"]`);

      slider.classList.remove("hidden");

      [...items].slice(0, visible).forEach((item, indexItem) => {
        item.classList.remove("hidden");
        [...lineItems].slice(0, visible).forEach((lineItem, indexLineItem) => {
          lineItem.classList.remove("hidden");
        });
        [...lineDotItems].slice(0, visible).forEach((lineItemDot, indexLineDotItem) => {
          lineItemDot.classList.remove("hidden");
          if (indexLineDotItem == indexItem && indexLineDotItem != [...lineDotItems].length - 1) {
            setTimeout(() => {
              lineItemDot.style.marginBottom = `${item.offsetHeight + 8}px`;
            }, 100);
          }
        });
      });

      if (Number(maxActivities) > Number(visible)) {
        this.buttonLoadMore.classList.remove("hidden");
      } else {
        this.buttonLoadMore.classList.add("hidden");
      }
    }

    visibleMobile() {
      this.buttonLoadMore.classList.add("hidden");
      const buttonYearsActive = this.querySelector("[data-year][data-active='true']");
      const year = buttonYearsActive.getAttribute("data-year");
      const slider = this.querySelector(`[data-slider="${year}"]`);
      const items = this.querySelectorAll(`[data-slider="${year}"] [data-recent-activities-item="${year}"]`);

      slider.classList.remove("hidden");

      [...items].forEach((item) => {
        item.classList.remove("hidden");
      });

      if (items.length > 1) {
        this.initSlider(slider);
      } else if (this.flkty != null) {
        this.flkty.destroy();
      }
    }

    initSlider(slider) {
      if (this.flkty != null) {
        this.flkty.destroy();
      }

      this.flkty = new Flickity(slider, {
        pageDots: true,
        prevNextButtons: false,
        wrapAround: false,
        adaptiveHeight: true,
        cellAlign: "left",
        groupCells: false,
        contain: true,
        autoPlay: 3000,
        on: {
          ready: () => {
            setTimeout(() => this.flkty.resize(), 1e3);
          },
        },
      });
      this.flkty.reposition();
    }
  }
  if (!customElements.get("recent-activities")) {
    customElements.define("recent-activities", RecentActivities);
  }

  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate, window.Swiper);
